const styles: {[key: string]: React.CSSProperties} = {
  '3XL': {
    fontSize: 30,
  },
  '2XL': {
    fontSize: 26,
  },
  XL: {
    fontSize: 22,
  },
  L: {
    fontSize: 20,
  },
  M: {
    fontSize: 18,
  },
  S: {
    fontSize: 16,
  },
  XS: {
    fontSize: 15,
  },
  '2XS': {
    fontSize: 14,
  },

  Regular: {
    fontWeight: 300,
  },
  Semibold: {
    fontWeight: 500,
  },
  Bold: {
    fontWeight: 700,
  },
  Italic: {
    fontStyle: 'italic',
  },
};

export default styles;
